
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchCobranzaByDni"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dni"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propias"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchCobranzaByDni"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dni"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dni"}}},{"kind":"Argument","name":{"kind":"Name","value":"propias"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propias"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaCobranza"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaImputacion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"montoCobrado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dniDeudor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombreDeudor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cuilDeudor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idRapipago"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agencia"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"facturas"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"canalCobro"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cuentaDestino"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"origenCreacion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cbu"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nroProducto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"jobId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errorImputacion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tipificacion"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":579}};
    doc.loc.source = {"body":"query fetchCobranzaByDni($dni: String!, $propias: Boolean){\n    fetchCobranzaByDni(dni: $dni, propias: $propias){\n        id\n        fechaCobranza\n        fechaImputacion\n        montoCobrado\n        dniDeudor\n        nombreDeudor\n        cuilDeudor\n        idRapipago\n        agencia{\n            id\n            nombre\n        }\n        facturas{\n                id\n                id\n            }\n        canalCobro\n        cuentaDestino\n        origenCreacion\n        cbu\n        nroProducto\n        estado\n        jobId\n        errorImputacion\n        tipificacion\n    }\n}\n\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["fetchCobranzaByDni"] = oneQuery(doc, "fetchCobranzaByDni");
        
